import React from "react";

const SlideWrapper = ({ children, preventCenterAlignment }) => {
  return (
    <div
      className={`shadow-2xl rounded-md h-[calc(100vh-4em)] w-full flex flex-col ${
        !preventCenterAlignment && "items-center justify-center "
      } dark:bg-gray-800 p-2 md:p-4 pt-8`}
    >
      {children}
    </div>
  );
};

export default SlideWrapper;
